module.exports = __webpack_public_path__ + "static/media/icon-dashboard-canceled.ab334830.svg";